<div class="ps-autocomplete">
  <input
    #input
    type="text"
    class="ps-input"
    [value]="value"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur()"
    autocomplete="off"
    spellcheck="false"
    />
    @if (matches.length) {
      <ul
        class="ps-matches"
        [style.max-height.px]="matchesMaxHeight"
        (mousedown)="$event.preventDefault()"
        >
        @for (m of matches; track m; let i = $index) {
          <li
            [class.active]="i === highlightIndex"
            (mousedown)="$event.preventDefault(); selectMatch(m)"
            >
            <div class="ps-row-main">
              <span class="ps-name">{{ m.name }}</span>
              <span class="ps-upc">{{ m.upc }}</span>
              <span
                class="ps-description"
                [title]="m.description"
              >{{ m.description }}</span>
              <span class="ps-price">{{ m.sale_price_rate ? '$' + m.sale_price_rate : '' }}</span>
            </div>
          </li>
        }
      </ul>
    }
  </div>
